import { BaseSetup } from "appworks/boot/base-setup";
import { Components } from "appworks/components/components";
import { canvasManager } from "appworks/graphics/canvas/canvas-manager";
import { Text } from "appworks/graphics/pixi/text";
import { Services } from "appworks/services/services";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { deviceInfo } from "appworks/utils/device-info";
import { gamevy } from "gamevy/gamevy";
import { GenericComponentFactory } from "slotworks/components/factories/generic-component-factory";
import { JurisdictionComponent } from "slotworks/components/jurisdiction/jurisdiction-component";
import { slotModel } from "slotworks/model/slot-model";
import { XBetAutoplay } from "slotworks/services/autoplay/xbet-autoplay";
import { EpicGamevyFreegamesComponent } from "./components/epic-gamevy-freegames-component";
import { EpicUIColourComponent } from "./components/epic-ui-colour-component";
import { EpicSetupUI } from "./setup/epic-setup-ui";

export class EpicSetup extends BaseSetup {

    public setupCanvas(): void {
        deviceInfo.selectLayout({
            phone: "mobile",
            tablet: "mobile",
            desktop: "desktop"
        });

        canvasManager.fullScreenEnabled = true;
        canvasManager.setPortraitEnabled(true);
        canvasManager.setPortraitCanvasEnabled(deviceInfo.layoutId === "mobile");
    }

    public setupComponents(): void {
        Components.register(new GenericComponentFactory(EpicUIColourComponent));
        Components.register(new GenericComponentFactory(JurisdictionComponent));
        Components.register(new GenericComponentFactory(EpicGamevyFreegamesComponent));
    }

    public setupServices(): void {
        Services.AutoplayType = XBetAutoplay;
    }

    public setupUI(...factories: ControlFactory[]): void {
        const autoplay = slotModel.read().autoplay;
        if (Services.jurisdiction.isUnlimitedAutoplayEnabled()) {
            autoplay.autoplays.values = [25, 50, 75, 100, Number.POSITIVE_INFINITY];
        } else {
            const autoplayLimits = Services.jurisdiction.getAutoplayLimits();
            if (autoplayLimits?.length) {
                const length = autoplayLimits.length;
                autoplay.autoplays.values = autoplayLimits.slice(length - 5, length);
            } else {
                autoplay.autoplays.values = [10, 25, 50, 75, 100];
            }
        }
        slotModel.write({ autoplay });

        EpicSetupUI(...factories);
    }

    public setupLayers() {
        Text.useDualPositionScale = true;
    }

    public onReady(): void {
        gamevy.trackBetChanges();
    }
}
